<template>
  <NavMenu />
  <router-view :key="$route.path" />
  <Footer
    v-if="
      $route.path != '/onze-bevindingen/nieuwsbrief' &&
      $route.path != '/nieuwsbericht'
    "
  />
</template>

<script>
import NavMenu from './components/NavMenu.vue';
import Footer from './views/Footer.vue';
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';

export default {
  name: 'App',
  components: {
    NavMenu,
    Footer,
  },
  setup() {
    const { t, locale } = useI18n();

    watch(
      () => locale.value,
      () => {
        document.title = t('navbar.title');
      },
      { immediate: true }
    );

    return {};
  },
};
</script>
